var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-player-setting-options',{attrs:{"options":_vm.options,"valueAttr":"code","labelAttr":"name","defaultValue":_vm.currentAudioChoice},on:{"change-value":function($event){_vm.changeText2Speech($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }